import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Button, Input, Drawer } from "antd";
import { message } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import Keyboard from "react-simple-keyboard";
import Close from "../../../../../assets/images/close-x.svg";
import User from "../../../../../assets/images/User.svg";
import SearchIcon from "../../../../../assets/images/searchIcon.svg";
import db from "../../../../../database";
import useCartStore from "../../../../../stores/useCartStore";
import useTransactionStore from "../../../../../stores/useTransactionStore";

const SalesRepDrawer = ({
  openSalesRep,
  setOpenSalesRep,
  cart,
  setCart,
  posConfig,
  keyboardType,
  setKeyboardType,
  salesRepValue,
  setSalesRepValue,
  selectedProductInCart,
  searchInputRef,
}) => {
  const [salesRepData, setSalesRepData] = useState([]);
  const [selectedSalesRep, setSelectedSalesRep] = useState({});
  const [open, setOpen] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const salesRepRef = useRef(null);
  const keyboardRef = useRef(null);

  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";

  const renderThumbHorizontalScroll = ({ style, ...props }) => {
    const thumbStyle = { width: "0px" };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  const fetchSalesRepData = async (searchTerm) => {
    const allReps = await db.salesRep.toArray();
    if (!searchTerm) return allReps;
    const term = searchTerm.toLowerCase();
    return allReps.filter((res) => res.name?.toLowerCase().includes(term) || res.code?.toLowerCase().includes(term));
  };

  const handleSearchChange = async (e) => {
    const value = e.target.value;
    setSalesRepValue(value);
    const data = await fetchSalesRepData(value);
    setSalesRepData(data);
    if (!value) {
      setSalesRepData(data);
      return;
    }
  };

  useEffect(() => {
    const run = async () => {
      const res = await db.salesRep.toArray();
      setSalesRepData(res);
    };
    run();
  }, []);

  useEffect(() => {
    if (openSalesRep?.flag && salesRepRef.current) {
      setTimeout(() => {
        salesRepRef.current.focus();
      }, 10);
    }
  }, [openSalesRep?.flag]);

  useEffect(() => {
    const fetchSalesReps = async () => {
      if (openSalesRep?.flag) {
        try {
          const data = await fetchSalesRepData("");
          setSalesRepData(data);
          setSalesRepValue("");
        } catch (error) {
          console.error("Error fetching sales representatives:", error);
        }
      }
    };
    fetchSalesReps();
  }, [openSalesRep?.flag]);

  const handleKeyboardInput = (key) => {
    if (key === "{shift}") {
      setLayoutName(layoutName === "shift" ? "default" : "shift");
      return;
    }
    if (key === "{number}") { setLayoutName("number"); return; }
    if (key === "{numbers}") { setLayoutName("numbers"); return; }
    if (key === "{small}") { setLayoutName("shift"); return; }
    if (key === "{caps}") { setLayoutName("default"); return; }
  };

  const handleClose = () => {
    if (posConfig?.requireSalesRepresentative === "Y") {
      const exchangeCartData = useCartStore.getState().exchangeCart;
      if (exchangeCartData) {
        if (exchangeCartData?.salesRepId === null) {
          setOpenSalesRep({ flag: true, level: "order" });
        }
      } else {
        if (cart?.salesRepId === null) {
          setOpenSalesRep({ flag: true, level: "order" });
        }
      }
      message.warning("Please select a Sales Representative to continue with this bill.");
    } else {
      setSelectedSalesRep({});
      setOpenSalesRep({ flag: false, level: "" });
      setOpen(false);
      setLayoutName("default");
      setSalesRepValue("");
      if (searchInputRef?.current) {
        searchInputRef?.current.focus();
      }
    }
  };

  const assignSalesRep = async (rep) => {
    let repId = rep.s_salesrep_id;
    let repName = rep.name;
    if (repId && !repName) {
      const dbRep = await db.salesRep.where("s_salesrep_id").equals(repId).first().catch(() => null);
      repName = dbRep?.name || "";
    }
    let cartData = isExchange ? (useCartStore.getState().exchangeCart || {}) : { ...cart };
    if (openSalesRep.level === "order") {
      cartData.salesRepId = repId;
      cartData.salesRepName = repName;
      if (isExchange) {
        useCartStore.getState().setExchangeCart({ ...cartData });
        const currentCart = useCartStore.getState().cart;
        setCart({ ...currentCart, salesRepId: repId, salesRepName: repName });
      } else {
        setCart({ ...cartData });
      }
      setSelectedSalesRep({});
      setOpenSalesRep({ flag: false, level: "" });
    } else if (openSalesRep.level === "line") {
      const updatedItems = cartData?.items?.map((lineItem) => {
        if (lineItem.productId === selectedProductInCart.productId && lineItem.lineId === selectedProductInCart.lineId) {
          return { ...lineItem, salesRepId: repId, salesRepName: repName };
        }
        return lineItem;
      });
      cartData = { ...cartData, items: updatedItems };
      if (isExchange) {
        useCartStore.getState().setExchangeCart(cartData);
        const currentCart = useCartStore.getState().cart;
        const mainItems = currentCart?.items?.map((lineItem) => {
          if (lineItem.productId === selectedProductInCart.productId && lineItem.lineId === selectedProductInCart.lineId) {
            return { ...lineItem, salesRepId: repId, salesRepName: repName };
          }
          return lineItem;
        });
        setCart({ ...currentCart, items: mainItems });
      } else {
        setCart(cartData);
      }
      setSelectedSalesRep({});
      setOpenSalesRep({ flag: false, level: "" });
    }
  };

  return (
    <>
      <Drawer
        closable={false}
        placement="bottom"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "7vh",
              fontSize: "1vw",
              position: "relative",
            }}
          >
            <p
              style={{
                fontSize: "1.5em",
                fontWeight: "500",
                color: "#0F0718",
                margin: 0,
              }}
            >
              Select a Sales Representative
            </p>

            <img
              src={Close}
              onClick={handleClose}
              style={{
                position: "absolute",
                right: "0.5vw",
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
        }
        closeIcon={null}
        open={openSalesRep?.flag}
        className="filter"
        headerStyle={{ background: "#f3f4f9", borderBottom: "none", padding: "0.5rem 1.5rem"}}
        styles={{ body: { background: "#f3f4f9", paddingBottom: 0, paddingTop: 0 } }}
        onClose={handleClose}
        height="90vh"
      >
        <Row style={{ paddingLeft: "0.7vw", paddingTop: "2vh", fontSize: "1vw", paddingBottom: "2vh" }}>
          <Col span={9}>
            <Input
              type="text"
              ref={salesRepRef}
              value={salesRepValue}
              className="productSearch"
              placeholder="Search"
              id="sm-product-search"
              onChange={handleSearchChange}
              onFocus={() => {
                setKeyboardType({
                  searchCus: false,
                  parkedBill: false,
                  salesHistory: false,
                  salesHistoryCus: false,
                  product: false,
                  giftCardSearch: false,
                  salesRep: true,
                  addCustomer: false,
                });
                setTimeout(() => {
                  keyboardRef?.current?.setInput(salesRepValue);
                  setOpen(true);
                }, 300);
              }}
              onPressEnter={(e) => e.preventDefault()}
              style={{
                width: "35vw",
                padding: "5px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "1vw",
                color: "#0F0718",
                borderColor: "rgba(0, 0, 0, 0.25)",
              }}
              prefix={
                <img src={SearchIcon} alt="" style={{ width: "15px", height: "15px", paddingLeft: "0.2vw" }} />
              }
            />
          </Col>
        </Row>
        <Scrollbars style={{ height: "55vh", width: "100%" }} renderThumbHorizontal={renderThumbHorizontalScroll}>
          <Row gutter={[16, 16]}>
            {salesRepData?.map((res) => (
              <Col
                key={res.code}
                span={6}
                style={{
                  background: selectedSalesRep.code === res.code ? "#cae5bd" : "#fff",
                  borderRadius: "5px",
                  display: "flex",
                  alignItems: "center",
                  margin: "0 1rem",
                  padding: "0rem 0.5rem",
                }}
                onClick={() => {
                  setSelectedSalesRep(res);
                  assignSalesRep(res);
                }}
              >
                <img src={User} alt="" style={{ marginRight: "10px", height: "2.5rem", margin: "0.7rem 0" }} />
                <span style={{ marginLeft: "10px", margin: "0.7rem 0px 0.7rem 10px", fontSize: "1vw" }}>
                  <p style={{ margin: 0, fontWeight: 500, fontSize: "1em", color: "#0F0718" }}>{res.name}</p>
                  <span style={{ fontSize: "0.8em", fontWeight: 500, color: "#0F0718" }}>{res.code}</span>
                </span>
              </Col>
            ))}
          </Row>
        </Scrollbars>
        <Row>
          <Col span={24} style={{ textAlign: "right", paddingTop: "1rem" }}>
            <Button
              style={{ backgroundColor: "#0F0718", color: "#fff", height: "7vh", width: "15vw", borderRadius: "7px" }}
              disabled={!selectedSalesRep?.code}
              onClick={() => assignSalesRep(selectedSalesRep)}
            >
              Continue
            </Button>
          </Col>
        </Row>
      </Drawer>

      {open && posConfig?.showKeyboard === "Y" && (
        <Drawer placement="bottom" closable={false} styles={{ body: { paddingBottom: 0 } }} height="47vh" open={open && posConfig?.showKeyboard === "Y"} mask={false}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1vh" }}>
            <img src={Close} onClick={() => setOpen(false)} style={{ cursor: "pointer", width: "1.5vw" }} />
          </div>
          <div style={{ padding: "0 4vw 0" }}>
            <Keyboard
              keyboardRef={(r) => { keyboardRef.current = r; }}
              onChange={(val) => {
                if (keyboardType.salesRep) {
                  setSalesRepValue(val);
                  handleSearchChange({ target: { value: val } });
                  if (salesRepRef && salesRepRef.current) {
                    setTimeout(() => { salesRepRef.current.focus(); }, 10);
                  }
                }
              }}
              layoutName={layoutName}
              display={{
                "{bksp}": "⌫",
                "{numbers}": "123",
                "{shift}": "⇧",
                "{enter}": "Enter",
                "{space}": "Space",
                "{number}": "123",
                "{caps}": "ABC",
                "{small}": "abc",
              }}
              layout={{
                shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {bksp}", "{number} @ {space} . {enter}"],
                numbers: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{caps} {space} {enter}"],
                number: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{small} {space} {enter}"],
                default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {bksp}", "{numbers} @ {space} . {enter}"],
              }}
              onKeyPress={handleKeyboardInput}
            />
          </div>
        </Drawer>
      )}
    </>
  );
};

export default SalesRepDrawer;
